/* ============
 * City Transformer
 * ============
 */

import Transformer from './transformer';

export default class SimpleDetailOrderTransformer extends Transformer {

  static fetch(item) {
    return {
      id: item.id,
      name: item.number,
      number: item.number,
    };
  }

  static send(item) {
    return {
      id: item.id,
      name: item.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/simpleDetailOrder.js